import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';
import Dropdown from '@components/@core/Dropdown';
import Input from '@components/@core/Input';
import { CompanyType } from '~/services/config';

const CompanyBio = ({ onInput, bio, onThumbnail }) => {
    const handleInputChange = (name) => (value) => {
        name === 'primary_phone' ? onInput(name, value.replace(/[^0-9.]/g, '')) : onInput(name, value);
    };
    const { name, info, primary_phone, address, url } = bio;

    return (
        <div className="card mb-0 pb-0 vdra-company">
            <div className="p-2">
                <p className="dsl-b22 bold mb-3">Select Company Type</p>
                <Dropdown
                    className="mb-3"
                    placeholder="Select company type"
                    title="Type*"
                    width="fit-content"
                    align="right"
                    data={CompanyType}
                    getValue={(e) => e.name}
                    onChange={handleInputChange('type')}
                />
            </div>
            <div className="d-flex ssm-column ai-start flex-wrap p-2">
                <div className="d-flex-1">
                    <div className="d-flex ssm-column mb-3">
                        <span className="dsl-m12 logospan">Logo</span>
                        <Avatar type="logo" size="extraLarge" icon="fas fa-image" borderColor="#f6f7f8" borderWidth={2} upload onDrop={onThumbnail} />
                        <span className="dsl-m12 d-flex-1 mt-4 ms-3 ssm-l-0">Please keep in mind that your logo will be used as a rounded avatar.</span>
                    </div>
                    <Input title="Name*" placeholder="Type here..." value={name} onChange={handleInputChange('name')} />
                    <Input title="Info" name="info" placeholder="Type here..." value={info} onChange={handleInputChange('info')} as="textarea" rows="4" />
                </div>

                <div className="d-flex-1 ms-md-5">
                    <Input title="Phone" placeholder="Type here..." value={primary_phone} onChange={handleInputChange('primary_phone')} />
                    <Input title="Web" placeholder="Type here..." value={url} onChange={handleInputChange('url')} />
                    <Input title="Address" placeholder="Type here..." value={address} onChange={handleInputChange('address')} as="textarea" rows="2" />
                    <span className="dsl-m12 d-flex-1 mt-5 ms-3 ssm-l-0">* Required</span>
                </div>
            </div>
        </div>
    );
};

CompanyBio.propTypes = {
    onInput: PropTypes.func,
    onThumbnail: PropTypes.func,
};

CompanyBio.defaultProps = {
    onInput: () => {},
    onThumbnail: () => {},
};

export default memo(CompanyBio);
